import React from 'react'

const NavBar = () => (
  <nav className='navbar navbar-inverse navbar-fixed-top'>
    <div className='container-fluid'>
      <div className='navbar-header'>
        <a className='navbar-brand'>Home Movies</a>
      </div>
    </div>
  </nav>
)

export default NavBar



/** WEBPACK FOOTER **
 ** ./src/components/NavBar.jsx
 **/